import { Row, Col, Dropdown } from 'react-bootstrap';
import { getIconFromName } from '../../commons/utils/user.util';
import Avatar from '../../components/Avatar';
import Notifications from '../../containers/Notifications';
import useAuth from '../../hooks/auth.hook';
import './style.scss';

const Header = () => {
  const auth = useAuth();
  const { user } = auth;

  return (
    <Row id="main-header" className="mt-3 justify-content-end pe-3">
      <Notifications userId={user?.id} />
      <Col xs="auto">
        <Dropdown>
          <Dropdown.Toggle as={Avatar} id="dropdown-icon">
            {getIconFromName(user?.name)}
          </Dropdown.Toggle>

          <Dropdown.Menu className="avatar-menu">
            <Dropdown.Item onClick={() => auth.signout()}>Cerrar sesión</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </Col>
    </Row>
  );
};

export default Header;
